/** What this device can do about Web Push. Kept apart from the browser calls in push.ts so it can be tested. */

export type PushState = "unsupported" | "needs-home-screen" | "denied" | "off" | "on";

export interface PushEnvironment {
	serviceWorker: boolean;
	pushManager: boolean;
	/** An iPhone or iPad, where push only exists inside a web app added to the home screen (iOS 16.4+). */
	iOS: boolean;
	/** Running as the home-screen app rather than in a browser tab. */
	standalone: boolean;
	permission: "default" | "granted" | "denied";
	subscribed: boolean;
}

export function pushState(env: PushEnvironment): PushState {
	if (!env.serviceWorker || !env.pushManager) return env.iOS && !env.standalone ? "needs-home-screen" : "unsupported";
	if (env.permission === "denied") return "denied";
	return env.permission === "granted" && env.subscribed ? "on" : "off";
}

/** A VAPID public key, as `pushManager.subscribe` wants it. */
export function base64UrlToBytes(value: string): Uint8Array<ArrayBuffer> {
	const base64 = value.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(value.length / 4) * 4, "=");
	const binary = atob(base64);
	const bytes = new Uint8Array(new ArrayBuffer(binary.length));
	for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
	return bytes;
}
